<template>
  <div class="timeuntil">
    <div class="event">Days Until {{ event }}</div>
    <div class="until">{{ daysUntil }}</div>
    <br>
  </div>
</template>

<script>
  import { formatDistanceStrict } from "date-fns"
  export default {
    name: 'TimeUntil',
    props: {
      event: String,
      year: Number,
      month: Number,
      day: Number
    },
    data() {
      return {
        timerCount: 30,
        daysUntil: formatDistanceStrict(
          new Date(),
          new Date(this.year, this.month-1, this.day, 0, 0),
          { unit: "day"}
        )
      }
    },
    watch: {
      timerCount: {
        handler(value) {
          if (value > 0) {
            setTimeout(() => {
              this.timerCount--;
            }, 1000);
          }
        },
        immediate: true
      }
    }
  }
</script>

<style>
.event {

}
</style>